import React, { memo } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Icon } from '@material-ui/core';
import send from '../../../common/icons/sent@3x.png';
import fail from '../../../common/icons/failed@3x.png';
import read from '../../../common/icons/read@3x.png';
import received from '../../../common/icons/received@3x.png';
var useStyles = makeStyles(function (theme) {
  return {
    MuiCircularProgressSvg: {
      width: "15px",
      height: "15px",
      color: "#e0e0e0",
      margin: "0 4px"
    },
    failIcon: {
      color: "red"
    },
    imgStyle: {
      height: "20px",
      marginRight: "5px"
    },
    hoverStyle: {
      marginRight: "25px"
    }
  };
});

function SedndingStatus(_ref) {
  var status = _ref.status,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      hoverReaction = _ref.hoverReaction;
  var classes = useStyles({
    hoverReaction: hoverReaction
  });
  var statusIcon = '';
  console.log('status>>', status);

  switch (status) {
    case 'sent':
      statusIcon = /*#__PURE__*/React.createElement("img", {
        src: !hoverReaction ? send : null,
        alt: "",
        className: classes.imgStyle
      });
      break;

    case 'sending':
      statusIcon = /*#__PURE__*/React.createElement("svg", {
        className: classes.MuiCircularProgressSvg,
        viewBox: "22 22 44 44",
        style: style
      }, /*#__PURE__*/React.createElement("circle", {
        className: "MuiCircularProgress-circle MuiCircularProgress-circleIndeterminate",
        cx: "44",
        cy: "44",
        r: "20.2",
        fill: "none",
        strokeWidth: "3.6"
      }));
      break;

    case 'received':
      statusIcon = /*#__PURE__*/React.createElement("img", {
        src: received,
        alt: "",
        className: classes.imgStyle
      });
      break;

    case 'read':
      statusIcon = /*#__PURE__*/React.createElement("img", {
        src: read,
        alt: "",
        className: classes.imgStyle
      });
      break;

    case 'fail':
      statusIcon = /*#__PURE__*/React.createElement("img", {
        src: fail,
        alt: "",
        className: classes.imgStyle
      });
      break;

    default:
      statusIcon = '';
      break;
  }

  return statusIcon;
}

export default memo(SedndingStatus);